import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-dialog-view-menu',
  templateUrl: './dialog-view-menu.component.html',
  styleUrls: ['./dialog-view-menu.component.css']
})
export class DialogViewMenuComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
